var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":"status","label":"Státusz","show-overflow-tooltip":"","width":"150px"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('status-cell',{attrs:{"todo":scope.row,"type":_vm.type}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }